import React from "react";

const DashboardPage = ({title, children, stats}) => {
    return (
      <div className="dashboard-page">
        <h3 className="dashboard-page__title">{title}</h3>
        {children}
      </div>
    );
};

export default DashboardPage;
